"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
var getClassNames = utilities_1.memoizeFunction(function (styles, className) {
    return {
        root: styling_1.mergeStyles("window", className, styles.root),
        header: styling_1.mergeStyles("window-header", styles.header),
        titleContainer: styling_1.mergeStyles("window-title-container", styles.titleContainer),
        title: styling_1.mergeStyles("window-title", styles.title),
        actionBar: styling_1.mergeStyles("window-action-bar", styles.actionBar),
        action: styling_1.mergeStyles("window-action", styles.action),
        body: styling_1.mergeStyles("window-body", styles.body)
    };
});
exports.getClassNames = getClassNames;
